define('dashboard-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('dashboard.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Dashboard', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
        getListRegioes: function (imobl_codigo) {//pega os Frames Cadastrados
          return $q(function (resolve, reject) {
            notify.clearNotifications();
            $http.get(appRoute.linkTo('dashboard.getListRegioes', {imobl_codigo: imobl_codigo})).success(function (data) {
              if (data && data.notifications && !_.isEmpty(data.notifications)) {
                notify.addNotification(data.notifications);
              }
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },
        getSlider: function (imobl_codigo) {//pega os Frames Cadastrados
          return $q(function (resolve, reject) {
            notify.clearNotifications();
            $http.get(appRoute.linkTo('dashboard.getSlider')).success(function (data) {
              if (data && data.notifications && !_.isEmpty(data.notifications)) {
                notify.addNotification(data.notifications);
              }
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        }
      }
    }]);
});
